<script setup lang="ts">
import { useAppStore } from '@/stores/app'
import { hasClaroBalancer } from '@/business-rules'
import CreditCards from '@/components/common/Footer/CreditCards.vue'
import CountryFlags from '@/components/common/Footer/CountryFlags.vue'

const appStore = useAppStore()
</script>

<template>
  <footer
    class="flex flex-col my-2 space-y-3 text-xs text-center"
    itemscope
    itemtype="https://schema.org/Organization"
  >
    <span v-if="hasClaroBalancer(appStore.country)">
      Tu compra siempre es segura en Mi Claro Express, <span class="font-bold">Paquetes1</span> y
      <span class="font-bold">Paquetes2</span> son una página oficial de Claro.
    </span>
    <CreditCards />
    <span>
      Aceptamos tarjetas de crédito y débito <br />
      emitidas en <span class="font-bold"> {{ $t('landing.emmitedCountry') }} </span>
    </span>
    <CountryFlags />
  </footer>
</template>

<style lang="scss" scoped></style>
